<p-confirmDialog key="timeperiod" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPeriod"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPeriod"
		dataKey="PeriodID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PeriodNo-->
				<th>
					<p-columnFilter type="text" field="PeriodNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PeriodDesc-->
				<th>
					<p-columnFilter type="text" field="PeriodDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartTime-->
				<th></th>

				<!--EndTime-->
				<th></th>

				<!--TardyTime-->
				<th></th>

				<!--Update Button-->
				<th></th>
				<!--Clear Button-->
				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PeriodNo">Period Number<p-sortIcon field="PeriodNo"></p-sortIcon></th>
				<th pSortableColumn="PeriodDesc">Description<p-sortIcon field="PeriodDesc"></p-sortIcon></th>
				<th pSortableColumn="StartTime">Start Time<p-sortIcon field="StartTime"></p-sortIcon></th>
				<th pSortableColumn="EndTime">End Time<p-sortIcon field="EndTime"></p-sortIcon></th>
				<th pSortableColumn="TardyTimeDate">Tardy Time<p-sortIcon field="TardyTimeDate"></p-sortIcon></th>
				<th></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Period>
			<tr [pSelectableRow]="Period">
				<td
					*ngFor="let col of cols"
					style="font-weight: bold"
					[ngStyle]="{
						color: Period.TardyTime == '0001-01-01T00:00:00' ? 'Red' : 'Black'
					}"
				>
					{{ Period[col.field] }}
				</td>

				<td>
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						showTime="true"
						hourFormat="12"
						timeOnly="true"
						[(ngModel)]="Period.TardyTimeDate"
						name="TardyTimeDate"
						appendTo="body"
					></p-calendar>
					<p *ngIf="Period.TardyTime == '0001-01-01T00:00:00'" style="font-weight: bold; color: red">(Tardy Time Not Set)</p>
				</td>

				<td>
					<button class="btn btn-primary" (click)="onUpdate(Period)">Set Time</button>
				</td>
				<td>
					<button class="btn btn-primary" (click)="onReset(Period)">Reset Time</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
